import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { getOutputHelper } from '../../../shared/output-helpers/get-output-helper';
import { OutputType } from '../../../team-apis/otterdam/outputs/output';

export function emptyAnswerOutputValidator(
  outputType: OutputType,
): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const isEmptyAnswer = getOutputHelper(outputType).isAnswerBlank(
      control.value,
    );
    return isEmptyAnswer ? { emptyAnswer: { value: control.value } } : null;
  };
}
